import React, { CSSProperties } from 'react';

import './IconTitleListItem.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  icon?: React.ReactNode;
  title?: string;
  handleOnClick?: () => void;
}

const IconTitleListItem: React.FC<Props> = ({ icon, title, handleOnClick }) => {
  return (
    <div className="item-container" onClick={handleOnClick}>
      <div className="icon-container">{icon}</div>
      <div className="title-container">
        <label>{title}</label>
      </div>
    </div>
  );
};

export default IconTitleListItem;
